/* eslint-disable camelcase */
/* eslint-disable max-len */
export const video_interview = {
  'micro-test': 'Микрофонду текшерүү',
  'indicator-reacts': 'Тегерек индикатор сырткы добуштарды сезет. Аны толугу менен толтуруңуз',
  'if-indicator-donot-reacts': 'Эгер индикатор жооп бербесе же браузер кошумча уруксат сураса, "Жетүүгө уруксат берүү" баскычын басыңыз',
  'interview-finished': 'Жумуш маеги аяктады. Рахмат!',
  'answer-successfuly-sent': 'Жооптор ийгиликтүү жиберилди',
  'prepering-to-recording': 'Сизде даярданууга {seconds} сек. бар. Жаздыруу "Жаздырууну баштоо" баскычын басканыңыздан кийин башталат.',
  'current-step': '{maxStep} суроонун {currentStep}-суроосу',
  'question-text': 'Суроонун тексти:',
  'show-question': 'Суроону көрсөтүү',
  'test-record': 'Сынамык жаздыруу',
  'make-test-record': 'Сынамык жаздырууну жасаңыз: камерага бир нерсе деп сүйлөңүз. Жоопторуңуз кандай көрүнөрүн көрөсүз',
  'start-recording': 'Жаздырууну баштоо',
  'stop-recording': 'Жаздырууну баштоо',
  're-record': 'Жаздырууну баштоо',
  'turn-on-the-camera': 'Камераңызды иштетиңиз!',
  'selection-stages': 'Тандоо баскычтары',
  questionnaire: 'Анкета',
  'video-interview': 'Анкета',
};
